<!-- Modal Header -->
<div class="modal-header border-bottom">
  <h4 class="modal-title fw-bold header-font">Challenge Details</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<!-- Modal Content -->
<div class="modal-body">
  <div class="d-flex flex-column">
    <!-- Challenge Image -->
    <div *ngIf="challengeDetail?.image_url" class="mb-3">
      <img class="w-100 cms-card-radius" 
           [src]="challengeDetail?.image_url"
           [alt]="challengeDetail?.name"
           style="max-width: 100%;
    height: auto; object-fit: cover;">
    </div>
    
    <!-- Challenge Header Info -->
    <div>
      <div *ngIf="challengeDetail?.past_completions && challengeDetail?.occurrence === 'single'" class="mb-2">
        <span class="badge bg-success">
          Completed
        </span>
      </div>
      <div *ngIf="challengeDetail?.past_completions && challengeDetail?.occurrence === 'multiple'" class="mb-2">
        <span class="badge bg-secondary">
          Level {{ challengeDetail?.past_completions + 1 || 1 }}
        </span>
      </div>
      <h3 *ngIf="challengeDetail?.name" [ngClass]="challengeDetail?.past_completions && challengeDetail?.occurrence === 'single' ? 'fw-bold header-font mb-0' : 'fw-bold header-font mb-3'">
        {{ challengeDetail?.name }}
      </h3>
      
      <!-- Progress Section -->
      <ng-container *ngIf="challengeDetail?.progress[0]?.completed_steps != null && challengeDetail?.progress[0]?.total_steps != null && !(challengeDetail?.past_completions > 0 && challengeDetail?.occurrence === 'single')">
        <div>
          <h6 class="fw-semibold mb-2">Progress</h6>
          <div class="d-flex flex-row flex-nowrap align-items-center gap-3">
            <div class="progress flex-grow-1" style="height: 1rem;">
              <!-- Divide total steps by completed steps to get the percentage width for progress bar -->
              <div class="progress-bar progress-bar-striped" 
                   role="progressbar"
                   [style.width.%]="(challengeDetail?.progress[0]?.completed_steps / challengeDetail?.progress[0]?.total_steps) * 100"
                   [attr.aria-valuenow]="challengeDetail?.progress[0]?.completed_steps"
                   [attr.aria-valuemin]="0"
                   [attr.aria-valuemax]="challengeDetail?.progress[0]?.total_steps">
              </div>
            </div>
            <!-- Completed steps/Total Steps -->
            <small class="fw-bold text-nowrap">
              {{ challengeDetail?.progress[0]?.completed_steps }} / {{ challengeDetail?.progress[0]?.total_steps }}
            </small>
          </div>
        </div>
      </ng-container>
    </div>

    <hr class="my-3">

    <!-- Challenge Description -->
    <ng-container *ngIf="challengeDetail?.description">
      <div class="mb-3">
        <h6 class="fw-bold">Challenge Description</h6>
        <p class="mb-0">{{ challengeDetail?.description }}</p>
      </div>
    </ng-container>
    
    <!-- End Date Warning -->
    <ng-container *ngIf="challengeDetail?.end_date">
        <p class="fst-italic">
          Complete this challenge by {{ challengeDetail?.end_date | date:'short' }} to earn this reward.
        </p>
    </ng-container>
    
    <!-- Date Information -->
    <ng-container *ngIf="challengeDetail?.start_date || challengeDetail?.end_date">
      <hr class="my-3">
      <div class="row">
        <div class="col-6">
          <h6 class="fw-semibold">Start Date</h6>
          <small class="text-muted">{{ challengeDetail?.start_date | date:'shortDate' }}</small>
        </div>
        <div class="col-6">
          <h6 class="fw-semibold">End Date</h6>
          <small class="text-muted">{{ challengeDetail?.end_date | date:'shortDate' }}</small>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer border-top">
  <div class="w-100 d-flex justify-content-center">
    <button type="button" class="btn de-primary-btn w-100" (click)="openOrderTypeModal()" 
            *ngIf="!routeToOrderLoading"
            [disabled]="routeToOrderLoading">
      {{ (order$ | async) ? 'Back to Order' : 'Start New Order' }}
    </button>
    <button type="button" class="btn de-primary-btn w-100" disabled *ngIf="routeToOrderLoading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <span class="visually-hidden">Loading...</span>
    </button>
  </div>
</div>
